import React, { useState, useEffect } from "react";
import { HashLink } from "react-router-hash-link";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const NavLinks = () => {
  const { isLoggedIn, role, logout } = useAuth();
  const navigate = useNavigate();

  const [isMobile, setIsMobile] = useState(false);
  const [openMenu, setOpenMenu] = useState("");

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMenu = (menu) => {
    if (isMobile) {
      setOpenMenu(openMenu === menu ? "" : menu);
    }
  };

  const handleLogout = () => {
    logout();
    toast.success("Logged out successfully");
    navigate("/");
  };

  return (
    <div className="flex flex-col lg:flex-row lg:space-x-8 items-start lg:items-center">
      <HashLink to="/" smooth className="nav-link">
        Home
      </HashLink>
      <HashLink to="/about" smooth className="nav-link">
        About
      </HashLink>
      <HashLink to="/contact#contact" smooth className="nav-link">
        Contact Us
      </HashLink>

      {isLoggedIn && (
        <HashLink to="/know-my-college" smooth className="nav-link">
          TNEA - Know My College
        </HashLink>
      )}

      {/* TNPSC Dropdown */}
      <div
        className="relative group"
        onMouseEnter={() => !isMobile && setOpenMenu("tnpsc")}
        onMouseLeave={() => !isMobile && setOpenMenu("")}
      >
        <button onClick={() => toggleMenu("tnpsc")} className="nav-link flex items-center">
          TNPSC <span className="ml-1">{openMenu === "tnpsc" ? "▲" : "▼"}</span>
        </button>
        {(openMenu === "tnpsc" || (!isMobile && openMenu === "tnpsc")) && (
          <div className="dropdown-menu">
            <HashLink to="/#services" smooth className="dropdown-item">
              Group IV & VAO
            </HashLink>
            <HashLink to="/assistantEngineer" smooth className="dropdown-item">
              Combined Engineering (CESE)
            </HashLink>
            <HashLink to="/subInspector" smooth className="dropdown-item">
              Sub Inspector
            </HashLink>
            <HashLink to="/policeConstable" smooth className="dropdown-item">
              Police Constable
            </HashLink>
          </div>
        )}
      </div>

      {/* Training Dropdown */}
      <div
        className="relative group"
        onMouseEnter={() => !isMobile && setOpenMenu("training")}
        onMouseLeave={() => !isMobile && setOpenMenu("")}
      >
        <button onClick={() => toggleMenu("training")} className="nav-link flex items-center">
          Training <span className="ml-1">{openMenu === "training" ? "▲" : "▼"}</span>
        </button>
        {(openMenu === "training" || (!isMobile && openMenu === "training")) && (
          <div className="dropdown-menu">
            <HashLink to="/computerCourse" smooth className="dropdown-item">
              Summer computer course
            </HashLink>
            <HashLink to="/communication" smooth className="dropdown-item">
              Communication training
            </HashLink>
            <HashLink to="/counselling" smooth className="dropdown-item">
              Engineering counselling
            </HashLink>
            <HashLink to="/placement" smooth className="dropdown-item">
              Placement training
            </HashLink>
            <HashLink to="/project" smooth className="dropdown-item">
              Project training
            </HashLink>
          </div>
        )}
      </div>

      {/* Role based */}
      {isLoggedIn && role === "ADMIN" && (
        <HashLink to="/adminDashboard" smooth className="nav-link">
          Admin Dashboard
        </HashLink>
      )}
      {isLoggedIn && role === "PUPIL" && (
        <HashLink to="/userDashboard" smooth className="nav-link">
          User Dashboard
        </HashLink>
      )}

      {/* Login / Logout */}
      {!isMobile && (
        <>
          {!isLoggedIn ? (
            <HashLink to="/login" smooth className="nav-link">
              Login
            </HashLink>
          ) : (
            <button onClick={handleLogout} className="nav-link text-red-600">
              Logout
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default NavLinks;
